import { __assign } from "tslib";
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { AudioUploader } from './audio-uploader.comp';
import { getBaseReactDriver } from '../../common/base-driver';
export var createAudioUploaderDriver = function (elem) {
    var base = getBaseReactDriver(elem);
    return {
        isAudioPlayerVisible: function () { return base.isChildVisible('.simple-audio-player'); },
        isEmptyState: function () { return base.isChildVisible('.empty-state'); },
        base: base
    };
};
export var renderAudioUploaderAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(AudioUploader, __assign({}, props)));
    return createAudioUploaderDriver(elem);
};
//# sourceMappingURL=audio-uploader.driver.js.map